import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper } from '../../css';

const UserRole = ({ roles, labels, setUserRole }) => {
  return (
    <Wrapper>
      <div className="main-content-form-headers">
        <span className="select-placeholder">{labels.USER_ROLE}</span>
      </div>
      <select
        id="role"
        name="role"
        className="select-style"
        style={{ width: '100%' }}
        onChange={e => setUserRole(e.target.value)}
      >
        {roles
          .filter(role => ![1, 10].includes(role.id))
          .map(({ id, name }) => (
            <option key={name} value={id}>
              {name}
            </option>
          ))}
      </select>
      <div id="security_question_error_message" className="error_messages">
        <span className="frg-body-font-14px">{labels.SELECT_ROLE}</span>
      </div>
    </Wrapper>
  );
};

UserRole.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.any).isRequired,
  labels: PropTypes.shape({
    USER_ROLE: PropTypes.string,
    SELECT_ROLE: PropTypes.string
  }).isRequired,
  setUserRole: PropTypes.func.isRequired
};

export default UserRole;
